import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55c81140"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cocacola-s5-modal-header"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M19.025 1.62674C19.2948 1.35698 19.2948 0.919618 19.025 0.649862C18.7552 0.380106 18.3179 0.380105 18.0481 0.649861L9.69727 9.00072L1.34641 0.649861C1.07665 0.380105 0.639287 0.380106 0.369532 0.649862C0.0997757 0.919618 0.0997754 1.35698 0.369531 1.62674L8.72039 9.97759L0.370056 18.3279C0.100301 18.5977 0.100301 19.035 0.370056 19.3048C0.639813 19.5746 1.07717 19.5746 1.34693 19.3048L9.69726 10.9545L18.0476 19.3048C18.3174 19.5746 18.7547 19.5746 19.0245 19.3048C19.2942 19.035 19.2942 18.5977 19.0245 18.3279L10.6741 9.9776L19.025 1.62674Z",
    fill: "#303030"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "cocacola-s5-modal-title" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "cocacola-s5-modal-footer" }

import { onBeforeUnmount, onMounted } from 'vue';

interface Props {
  title?: string;
  modelValue: boolean;
  clickOverlayCancel?: boolean;
  showClose?: boolean;
  escCancel?: boolean;
}

interface Emits {
  (event: 'update:model-value', val: boolean): void;
  (event: 'opened'): void;
  (event: 'closed'): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    modelValue: { type: Boolean },
    clickOverlayCancel: { type: Boolean, default: true },
    showClose: { type: Boolean, default: true },
    escCancel: { type: Boolean, default: true }
  },
  emits: ["update:model-value", "opened", "closed"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update:model-value', val: boolean): void;
  (event: 'opened'): void;
  (event: 'closed'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title?: string, modelValue: boolean, clickOverlayCancel: boolean, showClose: boolean, escCancel: boolean }




const onClickOverlay = () => {
  if (props.clickOverlayCancel) {
    onClose();
  }
};

function onClose() {
  emits('update:model-value', false);
}

const popupId = `${Date.now()}-${Math.random().toFixed(4)}`;
const lockBodyClass = `popup-body-lock-${popupId}`;

function onEnter() {
  document.body.classList.add(lockBodyClass);
}

function onLeave() {
  document.body.classList.remove(lockBodyClass);
}

function onEsc(event: KeyboardEvent) {
  if (event.key === 'Escape' || event.keyCode === 27) {
    if (props.escCancel) {
      onClose();
    }
  }
}

onMounted(() => {
  document.addEventListener('keydown', onEsc);
});

onBeforeUnmount(() => {
  onLeave();
  document.removeEventListener('keydown', onEsc);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    appear: "",
    name: "modal-fade",
    onAfterEnter: _cache[1] || (_cache[1] = ($event: any) => (emits('opened'))),
    onAfterLeave: _cache[2] || (_cache[2] = ($event: any) => (emits('closed'))),
    onEnter: onEnter,
    onLeave: onLeave
  }, {
    default: _withCtx(() => [
      (__props.modelValue)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "cocacola-s5-modal",
            onClick: onClickOverlay
          }, [
            _createElementVNode("div", {
              class: "cocacola-s5-modal-body",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, [
              (__props.showClose)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("button", {
                      class: "button-close",
                      onClick: onClose
                    }, _hoisted_3)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["cocacola-s5-modal-content", { 'title-only': !_ctx.$slots.default }])
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _renderSlot(_ctx.$slots, "title", {}, () => [
                    (__props.title)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          innerHTML: __props.title
                        }, null, 8, _hoisted_5))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _renderSlot(_ctx.$slots, "default")
              ], 2),
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "footer")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})